import React, { Component } from 'react';
import SupportBase from "../common/SupportBase";

export class MmResources extends Component {

    componentWillUnmount() {
        console.log("unmount");
    }

    render() {
        console.log("loading spinner");
        return <SupportBase
            currentUser={this.props.currentUser}
            contentName={'mmResources'}
            title={'PROCEDURE 2.0 MONITORING AND MEASURING RESOURCES'}
            exportTitle={'<h2>Procedure P2.0 Monitoring and measuring resources</h2>'}
            exportFileName={'mm_resources.docx'}
            latestRevision={this.props.revision}
        />
    };
}

export default (MmResources);